module.exports = __webpack_public_path__ + "static/images/hourglass.e8bd8cbf205921646b4a420b9908787a.svg";